// extracted by mini-css-extract-plugin
export var resizer = "_g4-0";